module.exports = __webpack_public_path__ + "static/media/shopping-cart.9482a3f7.svg";